// src/Luggage.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Luggage_default = createIcon({
  displayName: "Luggage",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M8 5C8 3.895 8.895 3 10 3H14C15.105 3 16 3.895 16 5V6V7C16 7.552 16.448 8 17 8C17.552 8 18 7.552 18 7V6H20C21.105 6 22 6.895 22 8V19C22 20.105 21.105 21 20 21H4C2.895 21 2 20.105 2 19V8C2 6.895 2.895 6 4 6H6V7C6 7.552 6.448 8 7 8C7.552 8 8 7.552 8 7V6V5ZM14 5H10V6H14V5ZM14.5 11C15.328 11 16 11.672 16 12.5C16 13.328 15.328 14 14.5 14C13.672 14 13 13.328 13 12.5C13 11.672 13.672 11 14.5 11ZM19.0879 14.2773C18.9956 14.0921 18.8037 13.9898 18.6094 14.002C18.5446 14.006 18.4797 14.022 18.418 14.0527L13.6406 16.5684C13.3926 16.6914 13.2901 16.9932 13.4141 17.2402L13.9688 18.3457C14.0928 18.5917 14.3917 18.6923 14.6387 18.5703L19.416 16.0547C19.664 15.9317 19.7646 15.6298 19.6406 15.3828L19.0879 14.2773Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  Luggage_default
};
